import {
    AccountContracts, ContractDisplays, CustomerServiceRepresentative, CustomerServiceRepresentativeAssignedAccounts,
    MonitoringLog, MonitoringLogsByAccountNumber,
    MonitoringLogsByUser, MonitoringStatusItem
} from "../../../Controllers/CustomerServiceDashboard/CustomerServiceDashboard";
import Account = Mri.Accounts.Account;
import {ActiveDisplay} from "../../Displays/ActiveDisplay";
import {create} from "zustand";
import {devtools, persist} from "zustand/middleware";
import {createCustomerServiceDashboardActions, CustomerServiceDashboardActions} from "./actions";
import {immer} from "zustand/middleware/immer";
import {Draft, produce} from "immer";
import {getAllMonitoringLogs} from "../context";

interface CustomerServiceDashboardStateLoadingState {
    accounts: boolean;
    monitoringLogs: boolean;
    displaysByContract: boolean;
}
export interface CustomerServiceDashboardState {
    readonly monitoringLogs: MonitoringLog[];
    readonly monitoringLogsByUser: MonitoringLogsByUser;
    readonly monitoringLogsByAccountNumber: MonitoringLogsByAccountNumber;
    readonly monitoringStatusAccountList: MonitoringStatusItem[];
    readonly loading: CustomerServiceDashboardStateLoadingState;
    readonly error: any;
    readonly selectedLog: MonitoringLog | null;
    readonly selectedContract: Mri.Contracts.Contract | null;
    readonly selectedDisplay: ActiveDisplay | null;
    readonly accounts: Account[];
    readonly accountsVisibleToUser: Account[];
    readonly contracts: Mri.Contracts.Contract[];
    readonly accountContracts: AccountContracts;
    readonly displaysByContract: ContractDisplays;
    readonly customerServiceReps: CustomerServiceRepresentative[];
    readonly repAssignedAccounts: CustomerServiceRepresentativeAssignedAccounts;
}

export type CustomerServiceDashboardStore = CustomerServiceDashboardState & CustomerServiceDashboardActions;

const initialState: CustomerServiceDashboardState = {
    monitoringLogs: [],
    monitoringLogsByUser: {},
    monitoringLogsByAccountNumber: {},
    monitoringStatusAccountList: [],
    loading: {
        accounts: false,
        monitoringLogs: false,
        displaysByContract: false,
    },
    error: null,
    selectedLog: null,
    selectedContract: null,
    selectedDisplay: null,
    accounts: [],
    accountsVisibleToUser: [],
    contracts: [],
    accountContracts: {},
    displaysByContract: {},
    customerServiceReps: [],
    repAssignedAccounts: {},
};
export const useCustomerServiceDashboardStore = create<CustomerServiceDashboardStore>()(
    // devtools(
        persist(
            immer((set, get) => ({
                ...initialState,
                ...createCustomerServiceDashboardActions(set, get)
            })),
            {
                name: 'customer-service-dashboard-store',
            }
        ),
    // )
);